import { useMemo, useRef, useEffect, useCallback } from "react";
import "./listPositionPlayers.sass";

export default function ListPositionPlayers({ selectedPlayers, currentPlayers, handleSelectPlayer, removePlayer, disabled, accentColor, selectedColor }) {
  const selectedIndexes = useMemo(
    () => new Set(selectedPlayers.map((p) => p.index)),
    [selectedPlayers]
  );

  const ulRef = useRef(null);
  const thumbRef = useRef(null);

  const updateThumb = useCallback(() => {
    const ul = ulRef.current;
    const thumb = thumbRef.current;
    if (!ul || !thumb) return;

    const { scrollTop, scrollHeight, clientHeight } = ul;
    const hasOverflow = scrollHeight > clientHeight;

    thumb.parentElement.style.visibility = hasOverflow ? "visible" : "hidden";
    if (!hasOverflow) return;

    const trackHeight = clientHeight;
    const thumbHeight = Math.max(30, (clientHeight / scrollHeight) * trackHeight);
    const thumbTop = (scrollTop / (scrollHeight - clientHeight)) * (trackHeight - thumbHeight);

    thumb.style.height = `${thumbHeight}px`;
    thumb.style.transform = `translateY(${thumbTop}px)`;
  }, []);

  useEffect(() => {
    const ul = ulRef.current;
    if (!ul) return;
    updateThumb();
    ul.addEventListener("scroll", updateThumb);
    const ro = new ResizeObserver(updateThumb);
    ro.observe(ul);
    return () => {
      ul.removeEventListener("scroll", updateThumb);
      ro.disconnect();
    };
  }, [updateThumb, currentPlayers]);

  return (
    <div className="list-position-players">
      <div className="lpp-scroll-wrapper">
        <ul ref={ulRef}>
          {currentPlayers.map((player) => {
            const alreadySelected = selectedIndexes.has(player.index);
            const blocked = disabled && !alreadySelected;
            const className = ["simulator-selection-mx__player-item", alreadySelected && "selected", blocked && "blocked"]
              .filter(Boolean)
              .join(" ");

            // selectedColor para el texto/dot del item seleccionado, accentColor para el scrollbar
            const activeColor = selectedColor || accentColor;
            const selectedStyle = activeColor && alreadySelected
              ? { color: activeColor }
              : undefined;

            return (
              <li
                key={player.index}
                className={className}
                style={selectedStyle}
                onClick={() => {
                  if (alreadySelected) return removePlayer(player.index);
                  if (!blocked) handleSelectPlayer(player);
                }}
              >
                {player.nombre}
                {alreadySelected && (
                  <span style={activeColor ? { background: activeColor } : undefined}></span>
                )}
              </li>
            );
          })}
        </ul>
        <div className="lpp-scrollbar-track">
          <div
            className="lpp-scrollbar-thumb"
            ref={thumbRef}
            style={selectedColor ? { background: selectedColor } : undefined}
          />
        </div>
      </div>
    </div>
  );
}